import React, { useState } from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import classNames from "classnames";
import { useFormatDateHook } from "hooks";
import { Task } from "store/types";

import "./Info.styles.scss";

interface Props {
  creator?: Task["creator"];
  created?: Task["created_at"];
  lastUpdated?: Task["updated_at"];
}

export const Info: React.FC<Props> = ({ creator, created, lastUpdated }) => {
  const [isMore, setIsMore] = useState<boolean>(false);
  const formatDate = useFormatDateHook();
  return (
    <div className={classNames("task-info")}>
      <div onClick={() => setIsMore(!isMore)} className="task-info__head">
        <span className="task-info__title">More info</span>
        <ExpandMoreIcon
          className={classNames("icon", { "icon--reverse": !isMore })}
          onClick={() => setIsMore(!isMore)}
        />
      </div>
      {isMore && (
        <div className="task-info__body">
          <div className="task-info__row">
            <span className="task-info__text">Creator: </span>
            <span className="task-info__text">{creator?.full_name || "-"}</span>
          </div>
          <div className="rtask-info__ow">
            <span className="task-info__text">Created: </span>
            <span className="task-info__text">
              {formatDate({ date: created, format: "DD-MM-YYYY, HH:mm", empty: "-" })}
            </span>
          </div>
          <div className="task-info__row">
            <span className="task-info__text">Last Updated: </span>
            <span className="task-info__text">
              {formatDate({ date: lastUpdated, format: "DD-MM-YYYY, HH:mm", empty: "-" })}
            </span>
          </div>
          {/* <div className="task-info__row">
            <span className="task-info__text">Linked Entity: </span>
            <span className="task-info__text task-info__text--blue">{linkdedEntity?.title || "-"}</span>
          </div> */}
        </div>
      )}
    </div>
  );
};
